import React from 'react';
import { motion } from 'motion/react';
import { Download, Lock, Youtube } from 'lucide-react';
import { heroData } from '../data/mock';

const Hero = () => {
  const springConfig = {
    type: "spring",
    damping: 80,
    stiffness: 400,
    mass: 1
  };

  return (
    <section className="hero-gradient relative min-h-screen flex items-center overflow-hidden pt-24 pb-12">
      {/* Gradient overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/90 via-white/80 to-white/70 z-10"></div>
      
      <div className="container relative z-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Made in India Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springConfig, delay: 0.1 }}
            className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full mb-6"
          >
            <span>🇮🇳</span>
            <span className="text-sm font-medium">Made for India</span>
          </motion.div>

          {/* Main Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springConfig, delay: 0.2 }}
            className="display-hero mb-6 whitespace-pre-line"
            style={{
              fontSize: 'clamp(36px, 6vw, 72px)',
              fontWeight: 600,
              lineHeight: 1.1,
              letterSpacing: '-0.02em',
              color: '#0A0A0A'
            }}
          >
            {heroData.tagline}
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springConfig, delay: 0.3 }}
            className="body-large mb-8 max-w-2xl mx-auto"
            style={{
              fontSize: '18px',
              lineHeight: 1.6,
              color: '#3C3B3D'
            }}
          >
            {heroData.subtitle}
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springConfig, delay: 0.4 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6"
          >
            <a
              href={heroData.playStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center gap-2 hover:scale-105 transition-transform"
              style={{
                background: 'linear-gradient(135deg, #FF8C42 0%, #FF6B9D 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '26px',
                padding: '18px 32px',
                fontSize: '16px',
                fontWeight: 500,
                cursor: 'pointer',
                boxShadow: '0 4px 20px rgba(255, 107, 157, 0.3)'
              }}
            >
              <Download className="w-5 h-5" />
              Download Free on Play Store
            </a>
            <a
              href="https://www.youtube.com/@typeit4ukeyboard"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary inline-flex items-center gap-2"
              style={{
                background: '#FF0000',
                color: 'white',
                border: 'none',
                borderRadius: '26px',
                padding: '16px 28px',
                fontSize: '16px',
                fontWeight: 500,
                cursor: 'pointer'
              }}
            >
              <Youtube className="w-5 h-5" />
              Watch on YouTube
            </a>
          </motion.div>

          {/* Privacy Note */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springConfig, delay: 0.5 }}
            className="inline-flex items-center gap-2 text-gray-600 text-sm mb-12"
          >
            <Lock className="w-4 h-4" />
            <span>{heroData.privacyNote}</span>
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springConfig, delay: 0.6 }}
            className="grid grid-cols-3 gap-6 max-w-lg mx-auto"
          >
            <div className="text-center">
              <div className="text-3xl font-bold" style={{ color: '#FF6B9D' }}>22</div>
              <div className="text-sm text-gray-600">Indian Languages</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold" style={{ color: '#FF6B9D' }}>10+</div>
              <div className="text-sm text-gray-600">AI Modes</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold" style={{ color: '#FF6B9D' }}>Free</div>
              <div className="text-sm text-gray-600">To Download</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
